import React, { Component } from 'react';

import { connect } from 'react-redux';
import { fetchPlayers } from './redux/actions';
import './Players.scss';
import {
    defaultFirstPage,
    defaultItemsPerPage
} from '../../../services/Paging';
import { PlayersList } from './PlayersList';
import { isEqual } from 'lodash';
import {
    getSelectedBrandId,
    getSelectedJurisdictionCode
} from '../../../jurisdiction/redux/selectors';
import { pagingParams } from '../../../shared/helpers/url-params.helper';

class Players extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: {
                pageSize: defaultItemsPerPage,
                page: defaultFirstPage
            },
            sort: {},
            filters: {
                severity: null
            },
            username: null
        };
    }

    makeFiltersConfig = () => ({
        typeConfig: null,
        severityConfig: {
            label: 'Risk Level'
        },
        statusConfig: null
    });

    updatePagination = pagination =>
        this.setState(
            {
                ...this.state,
                pagination
            },
            () => this.fetchPlayersFromState()
        );

    updateSort = ({ sortingKey, sortDirection }) =>
        this.setState(
            {
                ...this.state,
                sort: {
                    sortType: sortingKey,
                    sortOrder: sortDirection
                }
            },
            () => this.fetchPlayersFromState()
        );

    handleApplyFilters = filters => {
        this.setState(
            {
                ...this.state,
                pagination: {
                    ...this.state.pagination,
                    page: defaultFirstPage
                },
                filters
            },
            () => this.fetchPlayersFromState()
        );
    };

    handleClearFilters = filters =>
        this.setState(
            {
                ...this.state,
                pagination: {
                    pageSize: defaultItemsPerPage,
                    page: defaultFirstPage
                },
                filters
            },
            () => this.fetchPlayersFromState()
        );

    handleRemoveFilter = filters =>
        this.setState(
            {
                ...this.state,
                filters
            },
            () => this.fetchPlayersFromState()
        );

    handleSearchByUsername = username =>
        this.setState(
            {
                ...this.state,
                pagination: {
                    ...this.state.pagination,
                    page: defaultFirstPage
                },
                username
            },
            () => this.fetchPlayersFromState()
        );

    componentDidUpdate(prevProps, prevState, snapshot) {
        // A page of the previous selection means nothing for the new one
        if (
            !isEqual(prevProps.jurisdictionCode, this.props.jurisdictionCode) ||
            !isEqual(prevProps.brandId, this.props.brandId)
        ) {
            this.setState(
                {
                    ...this.state,
                    pagination: {
                        ...this.state.pagination,
                        page: defaultFirstPage
                    }
                },
                () => this.fetchPlayersFromState()
            );
        }
    }

    fetchPlayersFromState() {
        const { jurisdictionCode, brandId } = this.props;

        this.props.fetchPlayers({
            jurisdiction: jurisdictionCode,
            brandId,
            partialUsername: this.state.username,
            ...pagingParams(this.state.pagination),
            ...this.state.sort,
            averageRisk: this.state.filters.severity
        });
    }

    componentDidMount() {
        this.fetchPlayersFromState();
    }

    render() {
        const { players, loading } = this.props;

        return (
            <div className="alerts-main-container players container">
                {/*todo make this generic*/}
                <PlayersList
                    data={players}
                    loading={loading}
                    pagination={{
                        ...this.state.pagination,
                        hasNextPage: this.props.pagination.hasNextPage
                    }}
                    onPaginationUpdated={pagination =>
                        this.updatePagination(pagination)
                    }
                    currentSortingKey={this.state.sort.sortType}
                    onSortUpdated={sort => this.updateSort(sort)}
                    filters={this.state.filters}
                    filtersConfig={this.makeFiltersConfig()}
                    applyFilters={this.handleApplyFilters}
                    clearFilters={this.handleClearFilters}
                    removeFilter={this.handleRemoveFilter}
                    searchByUsername={this.handleSearchByUsername}
                />
            </div>
        );
    }
}
const mapStateToProps = state => {
    const { data, error, loaded, loading, pagination } = state.players;

    return {
        jurisdictionCode: getSelectedJurisdictionCode(state),
        brandId: getSelectedBrandId(state),
        players: data,
        pagination,
        loaded,
        loading,
        error
    };
};
const mapDispatchToProps = dispatch => ({
    fetchPlayers: searchParams => dispatch(fetchPlayers(searchParams))
});

export default connect(mapStateToProps, mapDispatchToProps)(Players);
